import  "./Footer.css"

const Footer = () => {
  return (
    <div className="footer">
      <div className="footerItems">
        <a href="#home" className="fLinks"><h3 className="footerItem">Home</h3></a>
        <a href="#about" className="fLinks"><h3 className="footerItem">About</h3></a>
        <a href="#services" className="fLinks"><h3 className="footerItem">Services</h3></a>
        <a href="#projects" className="fLinks"><h3 className="footerItem">Projects</h3></a>
      </div>
      <div className="copyright">
        <h2 className="copName">made by vincent</h2>
        <h4 className="year">© 2023</h4>
      </div>
    </div>
  )
}

export default Footer